import Flowit from '../../../services/flowit';
import * as types from './types';

// eslint-disable-next-line no-unused-vars
export const load = ({ commit, rootState, dispatch }, params) => {
  commit(types.LOADING_DATA, true);
  Flowit.tickets.list(params)
    .then((response) => {
      commit(types.SET_TOTAL_RESOURCES, response.data.resources);
      commit(types.SET_TICKETS_LIST, response.data.tickets);
      commit(types.CURRENT_PAGE, response.data.page);
      commit(types.LOADING_DATA, false);
      commit(types.REMOVE_TICKET_DATA);
      commit(types.CLEAN_TICKET_MESSAGES);
    });
};

// eslint-disable-next-line no-unused-vars
export const get = ({ commit, rootState, dispatch }, ticketId) => {
  Flowit.tickets.get(ticketId)
    .then((response) => {
      commit(types.SET_TICKET_DATA, response.data);
      commit(types.SET_TICKET_MESSAGES, response.data.comments);
    });
};

// eslint-disable-next-line no-unused-vars
export const postNewTicket = ({ commit, rootState, dispatch }, params) => {
  Flowit.tickets.newTicket(params)
    .then((response) => {
      commit(types.ADD_NEW_RESOURCE_TO_COUNT, 1);
      commit(types.ADD_NEW_TICKET_TO_LIST, response.data[0]);
      commit(types.SET_NEW_TICKET_ID, response.data[0].id);
      commit(types.LOADING_DATA, false);
    });
};

// eslint-disable-next-line no-unused-vars
export const postNewComment = ({ commit, rootState, dispatch }, params) => {
  Flowit.tickets.newComment(params)
    .then((response) => {
      // console.log(`postNewComment response: ${JSON.stringify(response.data)}`);
      commit(types.ADD_TO_MESSAGES_LIST, response.data);
    });
};

export const uploadFiles = ({ commit, rootState, dispatch }, params) => {
  // Flowit.tickets.upload(params)
  //   .then(() => {
  //   });
};

// eslint-disable-next-line no-unused-vars
export const notifications = ({ commit, rootState, dispatch }) => {
  Flowit.tickets.notifications()
    .then((response) => {
      if (response.data) {
        commit(types.ENABLE_TICKETS_NOTIFICATIONS);
      }
    });
};

export const disableTicketNotifications = ({ commit }) => {
  commit(types.DISABLE_TICKETS_NOTIFICATIONS);
};

export const addToMessagesList = ({ commit }, message) => {
  commit(types.ADD_TO_MESSAGES_LIST, message);
};

export const setCurrentPage = ({ commit }, page) => {
  commit(types.CURRENT_PAGE, page);
};

export const setTotalResources = ({ commit }, total) => {
  commit(types.SET_TOTAL_RESOURCES, total);
};

export const setLimit = ({ commit }, limit) => {
  commit(types.LIMIT, limit);
};

export const setLoadingData = ({ commit }, status) => {
  commit(types.LOADING_DATA, status);
};

export const loadList = ({ commit }) => {
  commit(types.LOAD, true);
  Flowit.tickets.loadList()
    .then(response => {
      commit(types.LOAD_LIST, response.data.tickets);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.LOAD, false);
      commit(types.ERROR, error.response.data.message);
    });
};

export const getTicket = ({ commit }, ticketId) => {
  commit(types.LOAD, true);
  Flowit.tickets.get(ticketId)
    .then(response => {
      commit(types.GET_TICKET, response.data.ticket);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.LOAD, false);
      commit(types.ERROR, error.response.data.message);
    });
};

export const newTicket = ({ commit }, params) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.tickets.newTicket(params)
    .then(response => {
      commit(types.NEW_TICKET_RESPONSE, response.data.ticket);
      commit(types.SUCCESS_STATUS, true);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, error.response.data.message);
      commit(types.LOAD, false);
    });
};

export const addComment = ({ commit }, params) => {
  commit(types.LOAD, true);
  commit(types.SUCCESS_STATUS, false);
  commit(types.ERROR_STATUS, false);
  Flowit.tickets.addComment(params)
    .then(response => {
      commit(types.ADD_COMMENT_RESPONSE, response.data.comment);
      commit(types.SUCCESS_STATUS, true);
      commit(types.LOAD, false);
    })
    .catch(error => {
      commit(types.ERROR_STATUS, true);
      commit(types.ERROR_MESSAGE, error.response.data.message);
      commit(types.LOAD, false);
    });
};
